import { jsonProperty, Serializable } from 'ts-serializable';

export class FadInformationsExclusiveCourseModel extends Serializable {
    @jsonProperty(Number)
    codigo: number = -1;

    fadClasses: number[] = [];

    @jsonProperty(String)
    text: string = '';

    @jsonProperty(String)
    type: string = '';
}
